import React, { useState } from "react";
import InputDatoProdotto from "../../../modificaProdotti/elementiPagina/InputDatoProdotto";
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import InputDatoTendinaGenerico from "../../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import {
  arrotondaImporto,
  calcolaComposizioneRimborso,
  calcolaImportoArticolo,
  creaConfigurazioneIniziale,
  creaConfigurazioneInteraSpedizione,
  creaRigaConfigurazione,
  formattaEuro,
} from "./rimborsoUtils";

function Reso({
  utente,
  reso,
  handleChange,
  className,
  i,
  datiTendineOrdine,
  handleChangeImportoReso,
  articoliSpedizione,
  importoTotaleSpedizione,
  importoSpedizione,
  importoContrassegno,
  applicaComposizioneRimborso,
}) {
  const { inputClassesNOW, classiTastoSblocco } = stilePulsanti;
  const canUpdateLogistica = Boolean(utente?.permessiAPI?.["update:logistica"]);
  const [configurazioneRimborso, setConfigurazioneRimborso] = useState(() =>
    creaConfigurazioneIniziale(
      reso,
      articoliSpedizione,
      importoSpedizione,
      importoContrassegno,
    ),
  );
  const configurazioneInteraSpedizione = creaConfigurazioneInteraSpedizione(
    configurazioneRimborso,
    articoliSpedizione,
    importoContrassegno,
  );
  const anteprimaInteraSpedizione = calcolaComposizioneRimborso(
    configurazioneInteraSpedizione,
    importoSpedizione,
    importoContrassegno,
  ).totaleRimborso;
  const discordanzaInteraSpedizione =
    Math.abs(anteprimaInteraSpedizione - importoTotaleSpedizione) >= 0.01;
  const differenzaInteraSpedizione = Math.abs(
    arrotondaImporto(anteprimaInteraSpedizione - importoTotaleSpedizione),
  );

  let classiContenitore = className || "";
  if (!(i % 2 === 0)) {
    classiContenitore = classiContenitore + " sfondoColChiaro";
  }

  if (reso["Quantità"] < 1) {
    classiContenitore = classiContenitore + " eliminato";
  }

  const eliminaArticolo = function () {
    if (!canUpdateLogistica) {
      return;
    }
    handleChange({
      target: {
        value: 0,
        name: "resiErimborsiArr[" + i + ']["Quantità"]',
      },
    });
  };

  function toDate(stringDate) {
    if (stringDate) {
      const d = new Date(stringDate);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
    return null;
  }

  const aggiornaConfigurazione = function (updater) {
    setConfigurazioneRimborso((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (applicaComposizioneRimborso) {
        applicaComposizioneRimborso(i, next);
      }
      return next;
    });
  };

  const toggleTotaleSpedizione = function () {
    aggiornaConfigurazione((prev) => {
      const nuovoStato = !prev.totaleSpedizione;
      if (nuovoStato) {
        return creaConfigurazioneInteraSpedizione(
          prev,
          articoliSpedizione,
          importoContrassegno,
        );
      }
      return {
        ...prev,
        totaleSpedizione: false,
        articoli: (articoliSpedizione || []).map((articolo) =>
          creaRigaConfigurazione(articolo),
        ),
      };
    });
  };

  const toggleArticolo = function (articoloIndex) {
    aggiornaConfigurazione((prev) => {
      const articolo = articoliSpedizione?.[articoloIndex];
      const righe = [...prev.articoli];
      const rigaCorrente =
        righe[articoloIndex] || creaRigaConfigurazione(articolo);
      const selezionato = !rigaCorrente.selected;
      const quantity =
        selezionato && rigaCorrente.quantity === 0
          ? rigaCorrente.maxQuantity
          : selezionato
            ? rigaCorrente.quantity
            : 0;
      righe[articoloIndex] = {
        ...rigaCorrente,
        selected: selezionato,
        quantity,
        amount: selezionato ? calcolaImportoArticolo(articolo, quantity) : 0,
      };
      return { ...prev, totaleSpedizione: false, articoli: righe };
    });
  };

  const cambiaQuantitaArticolo = function (articoloIndex, value) {
    aggiornaConfigurazione((prev) => {
      const articolo = articoliSpedizione?.[articoloIndex];
      const righe = [...prev.articoli];
      const rigaCorrente =
        righe[articoloIndex] || creaRigaConfigurazione(articolo);
      const maxQuantity = rigaCorrente.maxQuantity;
      const quantity = Math.max(
        0,
        Math.min(maxQuantity, parseInt(value, 10) || 0),
      );
      righe[articoloIndex] = {
        ...rigaCorrente,
        selected: quantity > 0,
        quantity,
        amount: calcolaImportoArticolo(articolo, quantity),
      };
      return { ...prev, totaleSpedizione: false, articoli: righe };
    });
  };

  const cambiaImportoArticolo = function (articoloIndex, value) {
    aggiornaConfigurazione((prev) => {
      const articolo = articoliSpedizione?.[articoloIndex];
      const righe = [...prev.articoli];
      const rigaCorrente =
        righe[articoloIndex] || creaRigaConfigurazione(articolo);
      const amount = Math.max(0, arrotondaImporto(value));
      righe[articoloIndex] = {
        ...rigaCorrente,
        selected: amount > 0,
        quantity: amount > 0 ? Math.max(1, rigaCorrente.quantity || 1) : 0,
        amount,
      };
      return { ...prev, totaleSpedizione: false, articoli: righe };
    });
  };

  const toggleDetrazione = function (campo) {
    aggiornaConfigurazione((prev) => ({
      ...prev,
      [campo]: !prev[campo],
    }));
  };

  const cambiaImportoDetrazione = function (campoImporto, campoToggle, value) {
    aggiornaConfigurazione((prev) => {
      const importo = Math.max(0, arrotondaImporto(value));
      return {
        ...prev,
        [campoImporto]: importo,
        [campoToggle]: importo > 0 ? true : false,
      };
    });
  };

  return (
    <div
      className={
        classiContenitore +
        " items-center flex flex-wrap justify-between pa3 pl4 pr4 br4 mb3"
      }
    >
      <div className="f4 w-90 mb3">{i + 1}.</div>
      {canUpdateLogistica && eliminaArticolo && (
        <div
          className="w-10 material-icons b-100 bordoColAlt pointer tr mb3"
          onClick={eliminaArticolo}
        >
          delete
        </div>
      )}

      <InputDatoTendinaGenerico
        inputLabel="Tipo"
        datoName={"resiErimborsiArr[" + i + ']["resiTipo_reso"]'}
        elencoDati={datiTendineOrdine.tipoReso}
        datoId="resiTipo_reso"
        datoValue={reso?.["resiTipo_reso"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoTendinaGenerico
        inputLabel="Stato"
        datoName={"resiErimborsiArr[" + i + ']["resiStato_reso"]'}
        elencoDati={datiTendineOrdine.statoReso}
        datoId="resiStato_reso"
        datoValue={reso?.["resiStato_reso"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoProdotto
        inputLabel="Data rientro"
        tipoInput="date"
        datoName={"resiErimborsiArr[" + i + ']["resiData_rientro"]'}
        datoId="resiData_rientro"
        datoValue={
          reso?.["resiData_rientro"] && toDate(reso["resiData_rientro"])
        }
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-100"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoTendinaGenerico
        inputLabel="Mezzo rimborso"
        datoName={"resiErimborsiArr[" + i + ']["resiMezzo_rimborso"]'}
        elencoDati={datiTendineOrdine.pagamento}
        datoId="resiMezzo_rimborso"
        datoValue={reso?.["resiMezzo_rimborso"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-100"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />

      <InputDatoProdotto
        inputLabel="Data operaz."
        tipoInput="date"
        datoName={"resiErimborsiArr[" + i + ']["resiData_operazione"]'}
        datoId="resiData_operazione"
        datoValue={
          reso?.["resiData_operazione"] && toDate(reso["resiData_operazione"])
        }
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-100"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />

      <div className="w-100 ba br3 bordoColAlt pa3 mt2 mb3">
        <div className="fw6 mb2">Composizione rimborso</div>
        <div className="f7 gray mb3">
          Seleziona gli articoli della spedizione corrente e applica le
          trattenute solo quando servono.
        </div>

        <label className="flex items-center justify-between w-100 pv2 bb b--black-10 pointer">
          <span className="flex items-center">
            <input
              type="checkbox"
              checked={configurazioneRimborso.totaleSpedizione}
              onChange={toggleTotaleSpedizione}
              className="mr2"
            />
            <span className="fw5">Intera spedizione</span>
          </span>
          <strong>
            Anteprima: € {formattaEuro(anteprimaInteraSpedizione)}
          </strong>
        </label>
        {discordanzaInteraSpedizione && (
          <div className="f7 dark-red pv2 bb b--black-10">
            Attenzione: l’anteprima effettiva è diversa dal totale della
            spedizione (€ {formattaEuro(importoTotaleSpedizione)}). Differenza:
            € {formattaEuro(differenzaInteraSpedizione)}.
          </div>
        )}

        {(articoliSpedizione || []).map((articolo, articoloIndex) => {
          const riga =
            configurazioneRimborso.articoli?.[articoloIndex] ||
            creaRigaConfigurazione(articolo);
          return (
            <div
              key={
                articolo?.["ID Articolo"] ||
                articolo?.["Cod Viglietti Sport"] ||
                articoloIndex
              }
              className="w-100 pv2 bb b--black-10"
            >
              <div className="flex items-center justify-between">
                <label className="flex items-center w-100 w-60-ns pointer pr3">
                  <input
                    type="checkbox"
                    checked={riga.selected}
                    onChange={() => toggleArticolo(articoloIndex)}
                    className="mr2"
                  />
                  <span className="pa3 pl0">
                    <strong>
                      {articolo?.["Cod Viglietti Sport"] || "Articolo"}
                    </strong>
                    {" - "}
                    {articolo?.["Descrizione Articolo"] || ""}
                  </span>
                </label>

                <div className="flex-column items-center mt2 mt0-ns">
                  <div>
                    <input
                      type="number"
                      min="0"
                      max={riga.maxQuantity}
                      value={riga.quantity}
                      onChange={(e) =>
                        cambiaQuantitaArticolo(articoloIndex, e.target.value)
                      }
                      className={inputClassesNOW + " tc mr1"}
                    />
                    <span className="mr3">/{riga.maxQuantity}</span>
                  </div>
                  <div>
                    <span className="mr1">€</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={riga.amount}
                      onChange={(e) =>
                        cambiaImportoArticolo(articoloIndex, e.target.value)
                      }
                      className={inputClassesNOW + " w4 c"}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="flex items-center justify-between w-100 pv2 bb b--black-10">
          <label className="flex items-center pointer pr2">
            <input
              type="checkbox"
              checked={configurazioneRimborso.detrai990}
              onChange={() => toggleDetrazione("detrai990")}
              className="mr2"
            />
            <span>Detrai 9,90</span>
          </label>
          <div className="flex items-center">
            <span className="mr1">-€</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={configurazioneRimborso.detrai990Importo}
              onChange={(e) =>
                cambiaImportoDetrazione(
                  "detrai990Importo",
                  "detrai990",
                  e.target.value,
                )
              }
              className={inputClassesNOW + " w3 tc"}
            />
          </div>
        </div>

        <div className="flex items-center justify-between w-100 pv2 bb b--black-10">
          <label className="flex items-center pointer pr2">
            <input
              type="checkbox"
              checked={configurazioneRimborso.detraiSpedizione}
              onChange={() => toggleDetrazione("detraiSpedizione")}
              className="mr2"
            />
            <span>Detrai costi di spedizione di questa spedizione</span>
          </label>
          <div className="flex items-center">
            <span className="mr1">-€</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={configurazioneRimborso.detraiSpedizioneImporto}
              onChange={(e) =>
                cambiaImportoDetrazione(
                  "detraiSpedizioneImporto",
                  "detraiSpedizione",
                  e.target.value,
                )
              }
              className={inputClassesNOW + " w3 tc"}
            />
          </div>
        </div>

        <div className="flex items-center justify-between w-100 pv2">
          <label className="flex items-center pointer pr2">
            <input
              type="checkbox"
              checked={configurazioneRimborso.detraiContrassegno}
              onChange={() => toggleDetrazione("detraiContrassegno")}
              className="mr2"
            />
            <span>Detrai commissione contrassegno</span>
          </label>
          <div className="flex items-center">
            <span className="mr1">-€</span>
            <input
              type="number"
              min="0"
              step="0.01"
              value={configurazioneRimborso.detraiContrassegnoImporto}
              onChange={(e) =>
                cambiaImportoDetrazione(
                  "detraiContrassegnoImporto",
                  "detraiContrassegno",
                  e.target.value,
                )
              }
              className={inputClassesNOW + " w3 tc"}
            />
          </div>
        </div>

        {importoContrassegno > 0 && (
          <div className="f7 mt2 dark-red">
            Contrassegno presente: € {formattaEuro(importoContrassegno)}.
            Eventuali trattenute extra vanno regolate a mano nei campi qui
            sotto.
          </div>
        )}
      </div>

      <InputDatoProdotto
        inputLabel="Rimb. articoli"
        datoName={"resiErimborsiArr[" + i + ']["resiValore_merce"]'}
        tipoInput="number"
        datoId="resiValore_merce"
        datoValue={reso?.["resiValore_merce"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChangeImportoReso}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45 mr2"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoProdotto
        inputLabel="R. sped Ritorno"
        datoName={"resiErimborsiArr[" + i + ']["resiSpedizione_R"]'}
        tipoInput="number"
        datoId="resiSpedizione_R"
        datoValue={reso?.["resiSpedizione_R"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChangeImportoReso}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoProdotto
        inputLabel="R. sped Andata"
        datoName={"resiErimborsiArr[" + i + ']["resiSpedizione_A"]'}
        tipoInput="number"
        datoId="resiSpedizione_A"
        datoValue={reso?.["resiSpedizione_A"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChangeImportoReso}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45 mr2"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />
      <InputDatoProdotto
        inputLabel="Tot. rimborso"
        datoName={"resiErimborsiArr[" + i + ']["resiTotale_rimborso"]'}
        tipoInput="number"
        datoId="resiTotale_rimborso"
        datoValue={reso?.["resiTotale_rimborso"] ?? ""}
        datoPlaceHolder=""
        datoOnChange={handleChange}
        inputClass={inputClassesNOW + " w-80 h-100"}
        datoClass={"w-45"}
        labelClass={"wpx-60"}
        classiTastoSblocco={classiTastoSblocco}
        tastoCopiaAspetto="NO"
        modCompatta="SI"
        permessoScrittura={utente?.permessiAPI["update:database"] ? "SI" : "NO"}
      />

      <label htmlFor={"noteRimb_" + i} className="w-100 mt3">
        Note
      </label>
      {utente?.permessiAPI["update:database"] ? (
        <textarea
          type="text"
          rows="3"
          id={"noteRimb_" + i}
          name={"resiErimborsiArr[" + i + ']["resiNote"]'}
          value={reso?.["resiNote"] ?? ""}
          onChange={handleChange}
          className={inputClassesNOW + " w-100"}
        />
      ) : (
        <p>{reso?.["resiNote"] ?? ""}</p>
      )}
    </div>
  );
}

export default Reso;
